var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Onglets',{attrs:{"onglets":_vm.onglets_menu,"offset":0},model:{value:(_vm.choice),callback:function ($$v) {_vm.choice=$$v},expression:"choice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }